import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { Customer } from '../../../models/Customer';
import { Order } from '../../../models/Order';
import { GatewayOrder } from '../../../models/GatewayOrder';

@Component({
  selector: 'app-coin-usage',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './coin-usage.component.html',
  styleUrls: ['./coin-usage.component.css']
})
export class CoinUsageComponent implements OnInit {
  @Input() customer?: Customer | null;
  @Input() order?: Order | null;
  @Input() gatewayOrder?: GatewayOrder | null;
  @Input() coinsUsed: number | null = null;
  @Output() coinsUsedChange = new EventEmitter<number>();
  @Output() confirm = new EventEmitter<void>();

  ngOnInit(): void {
      this.coinsUsed = this.customer?.coinsCurrent ?? 0;
  }

  onCoinsUsedChange(value: number) {
    this.coinsUsedChange.emit(value);
  }

  openConfirmDialog() {
    this.confirm.emit();
  }

  /**
   * Check if coins can be used for this order
   * Coins can only be used if DateTo is at least 2 business days away
   */
  canUseCoins(): boolean {
    if (!this.gatewayOrder?.dateFrom) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const dateFrom = new Date(this.gatewayOrder.dateFrom);
    dateFrom.setHours(0, 0, 0, 0);

    const businessDaysUntilDateFrom = this.calculateBusinessDays(today, dateFrom);
    return businessDaysUntilDateFrom >= 2;
  }

  /**
   * Calculate the number of business days between two dates
   * Excludes weekends (Saturday and Sunday)
   */
  private calculateBusinessDays(startDate: Date, endDate: Date): number {
    let count = 0;
    const currentDate = new Date(startDate);

    while (currentDate < endDate) {
      const dayOfWeek = currentDate.getDay();
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        count++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return count;
  }

  /**
   * Check if coins are disabled for any reason
   */
  isCoinsDisabled(): boolean {
    return (
      this.order?.coinsUsed! > 0 ||
      this.order?.status?.name === 'Ausstehend' ||
      this.order?.status?.name === 'Genehmigt' ||
      !this.canUseCoins()
    );
  }
}
